import { DESKTOP } from './../../../../styles/breakpoints';
import styled from 'styled-components';
import Button from '../../../form/button/button';

export const Content = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    @media screen and (min-width: ${DESKTOP}) {
        align-items: center;
    }
`;

export const UnlockButton = styled(Button)`
    margin: 1rem;
`;

export const TranslateButton = styled.button<{active?: boolean}>`
    position: relative;
    margin: 0 0.5rem;
    padding: 1.2rem 1.5rem;
    background-color: white;
    border: 2px solid ${({ active, theme }) => active
        ? theme.colors.primaryBlue.main
        : 'transparent'
    };
    border-radius: 1rem;
    color: ${({ theme }) => theme.colors.primaryBlue.main};
    font-size: 1.25rem;

    span {
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translateY(120%);
        z-index: 1;
        font-size: 0.75rem;
        background-color: ${({ theme }) => theme.colors.primaryBlue.main};
        color: white;
        padding: 0.5rem;
        border-radius: 0.25rem;
        opacity: 0;
        transition: opacity 0.4s ease-in-out;
        white-space: nowrap;

        &::before {
            content: '';
            border-style: solid;
            border-color: ${({theme}) => theme.colors.primaryBlue.main} transparent;
            border-width: 0 6px 6px 6px;
            position: absolute;
            bottom: 95%;
            left: 5%;
            transform: translateX(160%);
        }
    }

    &:hover {
        background-color: #eee;
        border-color: ${({ theme }) => theme.colors.primaryBlue.hover};

        span {
            opacity: 1;
        }
    }
`;